import { render, staticRenderFns } from "./ButtonsSaveCancel.vue?vue&type=template&id=81e9dc46&scoped=true"
import script from "./ButtonsSaveCancel.vue?vue&type=script&lang=js"
export * from "./ButtonsSaveCancel.vue?vue&type=script&lang=js"
import style0 from "./ButtonsSaveCancel.vue?vue&type=style&index=0&id=81e9dc46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e9dc46",
  null
  
)

export default component.exports